import React, { useEffect, useState } from "react";
import Link from "@qlik/qlik/src/components/Link";
import { getCardMedia, getMicrocopyValueFromKeys } from "@qlik/qlik/src/lib/util/helpers";
import Media from "@qlik/qlik/src/components/Media";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import { BLOG_PATHNAME } from "@qlik/qlik/src/lib/constants/blog-constants";
import { getResourceInternalLinkCta } from "@qlik/qlik/src/lib/util/helpers";
import { BLOG_BUTTON_TEXT } from "@qlik/qlik/src/lib/constants/blog-constants";
import { formatDateRange } from "@qlik/qlik/src/lib/util/dates";
import { useI18n } from "@qlik/utils/i18nContext";

const ResourceCard = ({ data }) => {
    const { component, browsingContext } = data ?? {};
    const { i18n } = useI18n();

    const [date, setFormattedDateStr] = useState(null);

    const title = component?.title;
    const resourceImage = getCardMedia(component);
    let linkText = component?.ctaLabel ? component?.ctaLabel : component?.cta?.[0]?.text;
    let excerpt;
    let type;
    let href;

    useEffect(() => {
        setFormattedDateStr(formatDateRange(component?.startDate, component?.endDate, i18n.curr.langCode));
    }, [component]);
    const resourceUrlObject =
        component?.__typename === "ContentfulResource" ? getResourceInternalLinkCta(component) : {};
    switch (component?.__typename) {
        case "ContentfulBlog":
            excerpt = component?.excerpt?.excerpt;
            type = component?.topic?.[0]?.title;
            href = `/${BLOG_PATHNAME}/${component.slug}`;
            linkText = getMicrocopyValueFromKeys(component?.microcopyGroup, [BLOG_BUTTON_TEXT]);
            break;
        case "ContentfulResource":
            excerpt = component?.excerpt?.excerpt;
            type = component?.resourceType?.[0]?.title;
            href = i18n.getLangPrefixedPath(resourceUrlObject?.[0]?.internalLink?.slug);
            break;
        case "ContentfulCard":
            excerpt = component?.body?.raw ? renderRichText(component?.body) : "";
            type = component?.eyebrowText;
            href =
                component?.cta && component?.cta?.[0]?.internalLink !== null
                    ? i18n.getLangPrefixedPath(`/${component?.cta?.[0]?.internalLink?.slug}`)
                    : component?.cta?.[0]?.externalUrl;
            break;
        case "ContentfulEvent":
            excerpt = component?.description?.description;
            type = component?.type?.[0]?.title;
            href =
                component?.cta && component?.cta?.[0]?.internalLink !== null
                    ? i18n.getLangPrefixedPath(`/${component?.cta?.[0]?.internalLink?.slug}`)
                    : component?.cta?.[0]?.externalUrl;
            break;
        default:
            break;
    }

    const linkProps = {
        className:
            "group/resource block h-full p-5 pt-4.5 border border-stone/50 rounded lg:hover:shadow-lg transition-shadow duration-300",
        newWindow: browsingContext === "New Tab",
        to: href,
    };

    return (
        <div className="h-full">
            <Link {...linkProps}>
                <div className="contain-paint">
                    {resourceImage && (
                        <Media
                            media={resourceImage}
                            className="max-xl:max-w-87.5 w-full h-auto xl:h-60 object-cover lg:group-hover/resource:scale-105 transition-all duration-300"
                        />
                    )}
                </div>
                <div className="flex flex-col xl:h-[calc(100%-240px)] pt-7.5 px-2.5 pb-2.5 xl:pt-10 xl:pl-5 pr-5.5 xl:pb-5">
                    <span className="-z-1 absolute -inset-y-2.5 -inset-x-3.75 rounded bg-white shadow-xlSmall opacity-0 transition-opacity transition-300 xl:group-hover/link:opacity-100" />
                    {type && (
                        <span className=" text-ocean text-sm font-medium uppercase tracking-wide4 leading-none">
                            {type}
                        </span>
                    )}
                    {date && (
                        <span className="mt-2.5 text-gray/50 text-sm font-medium uppercase tracking-wide4 leading-none">
                            {date}
                        </span>
                    )}

                    {title && (
                        <div className="mt-5 mb-3.75 text-xl text-blue leading-tight tracking-normal font-semibold">
                            {title}
                        </div>
                    )}
                    {excerpt && <div className="mb-7.5">{excerpt}</div>}
                    {linkText && (
                        <span className="green-link mt-auto xl:group-hover/resource:text-dark-green xl:group-hover/resource:after:arrow-green-dark xl:group-hover/resource:after:translate-x-0.75">
                            {linkText}
                        </span>
                    )}
                </div>
            </Link>
        </div>
    );
};
export default ResourceCard;
